import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserProfileAboutSubpageComponent } from '@app/account/profile';
import { PaymentCheckoutWizardModule } from '@app/account/shared/payment-checkout-wizard/payment-checkout-wizard.module';
import { BreadcrumbsModule } from '@app/core/components/breadcrumbs/breadcrumbs.module';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { FilterContentComponent } from '@app/library/panes/filter-content/filter-content.component';
import { MeetingReviewFormComponent } from '@app/library/panes/meeting-review-form/meeting-review-form.component';
import { AuthorInfoComponent } from '@core/components/author-info/author-info.component';
import { BookmarkComponent } from '@core/components/bookmark/bookmark.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { ReviewsCarouselModule } from '@core/components/reviews-carousel/reviews-carousel.module';
import { UserServiceCardModule } from '@core/components/service-card/user-service-card.module';
import { SubscribeComponent } from '@core/components/subscribe/subscribe.component';
import { PipesModule } from '@core/pipes/pipes.module';

import { MeetingCheckoutWizardDialogModule } from '@shared/checkout-wizards/meeting-checkout-wizard-dialog';
import { IconComponent } from '@shared/icon/icon.component';
import { StatusBadgeComponent } from '@shared/layouts/status-badge/status-badge.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { SkeletonComponent } from '@shared/skeleton/skeleton.component';
import { DateFnsModule } from 'lingo2-ngx-date-fns';
import { InViewportModule } from 'ng-in-viewport';
import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule, OnUiTabsModule } from 'onclass-ui';
import { UserServiceCardFullComponent } from './user-service-card-full.component';
// eslint-disable-next-line max-len
import { UserServiceDebugClassroomsComponent } from './user-service-debug-classrooms/user-service-debug-classrooms.component';
import { UserServiceDebugScheduleComponent } from './user-service-debug-schedule/user-service-debug-schedule.component';
import { UserServiceMeetingsComponent } from './user-service-meetings/user-service-meetings.component';
import { UserServiceSurfaceBlockComponent } from './user-service-surface-block/user-service-surface-block.component';

@NgModule({
  imports: [
    LocaleSharedModule,
    CommonModule,
    RouterModule,

    DateFnsModule,
    PipesModule,
    UserServiceCardModule,
    ReviewsCarouselModule,
    InViewportModule,
    ModalModule,
    MobileModalModule,
    BreadcrumbsModule,
    OnUiCoverModule,
    OnUiButtonModule,
    OnUiTabsModule,
    PaymentCheckoutWizardModule,
    BookmarkComponent,
    OnUiCardMenuModule,
    SubscribeComponent,
    StatusBadgeComponent,
    UserProfileAboutSubpageComponent,
    FilterContentComponent,
    RatingComponent,
    MeetingCheckoutWizardDialogModule,
    SkeletonComponent,
    IconComponent,
    MeetingReviewFormComponent,
    AuthorInfoComponent,
    UserServiceSurfaceBlockComponent,
  ],
  declarations: [
    UserServiceCardFullComponent,
    UserServiceDebugScheduleComponent,
    UserServiceDebugClassroomsComponent,
    UserServiceMeetingsComponent,
  ],
  exports: [UserServiceCardFullComponent],
})
export class UserServiceCardFullModule {}
